import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { useEffect } from "react";
import { useState } from "react";

export default function ChartOutFlt({ data }) {
  const [convertData, setConvertData] = useState([]);
  useEffect(() => {
    if (data && data.length > 0) {
      const dataArray = data.map((item) => ({
        country: item.carrierCode,
        T1: item.terminalCode === "T1" ? item.weight : 0,
        T2: item.terminalCode === "T2" ? item.weight : 0,
      }));
      const groupedData = dataArray.reduce((result, item) => {
        const existingItem = result.find(
          (groupItem) => groupItem.country === item.country
        );

        if (existingItem) {
          // 이미 있는 경우 누적
          existingItem.T1 += item.T1;
          existingItem.T2 += item.T2;
        } else {
          // 없는 경우 새로운 그룹 추가
          result.push({ ...item });
        }
        return result;
      }, []);
      setConvertData(groupedData);
    }
  }, []);
  return (
    <ResponsiveBar
      data={convertData}
      keys={["T1", "T2"]}
      indexBy="country"
      margin={{ top: 10, right: 40, bottom: 60, left: 60 }}
      padding={0.1}
      valueFormat=" >-.2f"
      groupMode="stacked"
      layout="horizontal"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={["#3c6e71", "#9bba74"]}
      borderColor={{
        from: "color",
        modifiers: [["darker", "1.7"]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "FLT",
        legendPosition: "middle",
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 10]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 45,
          translateY: 10,
          itemsSpacing: 2,
          itemWidth: 91,
          itemHeight: 10,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 12,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      ariaLabel="Nivo bar chart demo"
      barAriaLabel={(e) =>
        e.id + ": " + e.formattedValue + " in country: " + e.indexValue
      }
    />
  );
}
